var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysReports = function SvgSysReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.749 19.196a2.753 2.753 0 0 1-2.75-2.752V5.754a.753.753 0 0 1 .751-.752h9.687a.753.753 0 0 1 .751.752v1.914h2.261a.748.748 0 0 1 .53.22.75.75 0 0 1 .217.532v8.526a2.25 2.25 0 0 1-1.393 2.08c-.273.113-.566.17-.862.17H7.75Zm8.434-2.25a.754.754 0 0 0 1.51 0v-7.78h-1.515l.005 7.78Zm-9.687-.5a1.256 1.256 0 0 0 .774 1.158c.152.063.314.096.479.096h7.073a2.233 2.233 0 0 1-.138-.752V6.496H6.497v9.95Zm1.815.142a.746.746 0 0 1-.75-.746v-2.78a.752.752 0 0 1 .75-.751h4.567a.748.748 0 0 1 .747.752v2.779a.748.748 0 0 1-.46.691.742.742 0 0 1-.287.055H8.31Zm.747-1.5h3.069v-1.281H9.058v1.281Zm-.747-4.77a.75.75 0 0 1 0-1.5h4.567a.75.75 0 1 1 0 1.5H8.31Z"
  })));
};
export default SvgSysReports;